// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tooltip.notification-settings-tooltip {\n  z-index: 100001;\n  max-width: 250px;\n}\n", ""]);
// Exports
module.exports = exports;
